import Color from '../Color.mjs'
import superMeta from '../_ARCH_CAT/metaArchCatNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    childType: 'SS',
    detailUrl: '/ProjectFcMap',
    name: '程序模型',
    type: 'CAT_SS',
}
